import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { Popup, Header, Title, Body, Footer } from '@calendly/ui/components/popup';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
const popupBoldWrapperCss = "p1ehewrb";
const PopupBoldWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(popupBoldWrapperCss, props.className)} />;
});

// i18n-tasks-use t('publisher.event_type_editor.sections.event_details.fields.location.organizer.google_conference.title')
// i18n-tasks-use t('publisher.event_type_editor.sections.event_details.fields.location.organizer.google_conference.body')
// i18n-tasks-use t('publisher.event_type_editor.sections.event_details.fields.location.organizer.google_conference.bold_body')
// i18n-tasks-use t('publisher.event_type_editor.sections.event_details.fields.location.organizer.microsoft_teams_conference.title')
// i18n-tasks-use t('publisher.event_type_editor.sections.event_details.fields.location.organizer.microsoft_teams_conference.body')
// i18n-tasks-use t('publisher.event_type_editor.sections.event_details.fields.location.organizer.microsoft_teams_conference.bold_body')

export const ExplanationPopup = ({
  locationKind,
  isOpen,
  onClose
}) => <Popup withCloseButton isOpen={isOpen} onClose={onClose}>
    <Header>
      <Title>
        {I18n.t(`publisher.event_type_editor.sections.event_details.fields.location.organizer.${locationKind}.title`)}
      </Title>
    </Header>
    <Body>
      <BodyText>
        {I18n.t(`publisher.event_type_editor.sections.event_details.fields.location.organizer.${locationKind}.body`)}
      </BodyText>
      <PopupBoldWrapper>
        <BodyText weight="bold">
          {I18n.t(`publisher.event_type_editor.sections.event_details.fields.location.organizer.${locationKind}.bold_body`)}
        </BodyText>
      </PopupBoldWrapper>
    </Body>
    <Footer>
      <Button onClick={onClose}>
        {I18n.t('publisher.event_type_editor.sections.event_details.fields.location.organizer.button_text')}
      </Button>
    </Footer>
  </Popup>;

require("./explanation_popup.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./explanation_popup.js");